// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3lOeP","label":"Radio_label__3BVYp","checkMark":"Radio_checkMark__2Ji-9","disabled":"Radio_disabled__3mc86"};